@if(allLessonTypes.length > 0){
<div class="cards grid flex-wrap justify-center">
    @for(lessonType of allLessonTypes; track $index){
    <div>
        <main-filter-card class="card" title="{{lessonType.lessonTypeName}}"
            id='{{lessonType.lessonTypeId}}'></main-filter-card>
    </div>
    }
</div>
}